var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky-container"},[_vm._t("default"),_vm._v(" "),(_vm.url !== null)?_c('div',{staticClass:"sticky-area",class:_vm.isShown && 'hide'},[_c('a',{staticClass:"button green flex-grow h-[50px]",attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v("Book Now")])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }